import React from "react";
import styles from './mochila.module.css';
import videoSrc from './video.mp4';

function MochilaBanner() {
    return (
        <section className={styles.bannerSection}>
            <div className={styles.container}>
                {/* Lado Esquerdo: Texto de Performance */}
                <div className={styles.content}>
                    <span className={styles.tag}>OPERATIONAL GEAR // TEST</span>
                    <h2 className={styles.title}>RESISTÊNCIA <span>EXTREMA.</span></h2>
                    <p className={styles.description}>
                        Projetada para suportar o rigor da selva urbana e selvagem. 
                        Costuras reforçadas e materiais de alta densidade testados sob carga máxima.
                    </p>
                    <div className={styles.badge}>DURABILIDADE CORDURA</div>
                </div>

                {/* Lado Direito: Vídeo Estilo GIF */}
                <div className={styles.videoContainer}>
                    <video 
                        className={styles.videoElement}
                        autoPlay 
                        muted 
                        loop 
                        playsInline
                    >
                        <source src={videoSrc} type="video/mp4" />
                        Seu navegador não suporta vídeos.
                    </video>
                    {/* Overlay sutil sobre o vídeo para combinar com o design */}
                    <div className={styles.videoOverlay}></div>
                </div>
            </div>
        </section>
    );
}

export default MochilaBanner;